import { useQuery } from "@apollo/client";

import { type RemoteApiSpec } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import { type GetRemoteApiSpecsQuery, getRemoteApiSpecs } from "../api/graphql";

export const useRemoteApiSpecs = (): ApolloResult<{
    specs: readonly RemoteApiSpec[];
}> => {
    const { data, error, loading } = useQuery<GetRemoteApiSpecsQuery>(getRemoteApiSpecs, {
        // to support partial results
        errorPolicy: "all",
    });

    const specs =
        data?.remoteApiSpecs.map((spec) => ({
            ...spec,
            customVisibilityUsersList: spec.customVisibilityUsersList ?? [],
        })) ?? [];

    return { specs, error, loading };
};
